import { csx } from '@vtex/admin-ui'

const styles = {
  view: {
    content: csx({ gap: '$space-5' }),
    tag: csx({ marginX: '$space-1' }),
  },
  editor: {
    trigger: {
      scope: csx({ display: 'flex', gap: '$space-4', flexDirection: 'column' }),
      content: csx({
        display: 'flex',
        flexDirection: 'column',
        gap: '$space-10',
      }),
    },
  },
}

export default styles
